export const heroContent = {
  tr: {
    title: "Akıllı Vana Çözümleri",
    subtitle:
      "Operasyon güvenliğini, saha verimliliğini ve prosedür disiplinini aynı anda güçlendiren mühendislik odaklı manuel vana çözümleri sunuyoruz.",
    cta: "Çözümleri İnceleyin",
    ctaLink: "/cozumler",
    backgroundImage: "/images/solutions/ind-hero.webp",
  },
  en: {
    title: "Smart Valve Solutions",
    subtitle:
      "We deliver engineering-led manual valve solutions that make critical operations safer, more disciplined and easier to manage in the field.",
    cta: "Explore Solutions",
    ctaLink: "/solutions",
    backgroundImage: "/images/solutions/ind-hero.webp",
  },
  az: {
    title: "Ağıllı Vana Həlləri",
    subtitle:
      "Əməliyyat təhlükəsizliyini, prosedur intizamını və sahə səmərəliliyini birlikdə gücləndirən mühəndislik yönümlü manual vana həlləri təqdim edirik.",
    cta: "Həlləri Kəşf Edin",
    ctaLink: "/heller",
    backgroundImage: "/images/solutions/ind-hero.webp",
  },
};

export const bulletinContent = {
  tr: {
    title:
      "Kritik vana operasyonlarında güvenlik ve verimliliği nasıl artırabileceğinizi keşfedin.",
    cta: "Bilgi Bültenimize Kaydolun",
  },
  en: {
    title:
      "Discover practical ways to improve safety and efficiency in critical valve operations.",
    cta: "Subscribe to Our Newsletter",
  },
  az: {
    title:
      "Kritik vana əməliyyatlarında təhlükəsizlik və səmərəliliyi necə artıracağınızı kəşf edin.",
    cta: "Bülletenə Abunə Olun",
  },
};
